import {Directive, Input, TemplateRef, ViewContainerRef} from "@angular/core";

@Directive({
    selector: '[wmTemplate]',
})
export class WmTemplate {
    @Input('wmTemplate') name: string;

    constructor(public template: TemplateRef<any>, public viewContainer: ViewContainerRef) {
    }
}
